const UploadResult = ({ result }) => {
  if (!result) return null

  const summaryKeys = ['inserted', 'updated', 'processed', 'movementsCreated', 'errors', 'batchCode']

  return (
    <div className='bg-slate-50 border border-slate-200 rounded-xl p-3 space-y-2'>
      <div className='flex flex-wrap gap-3 text-xs text-slate-700'>
        {summaryKeys.map(key => (
          <span key={key} className='px-2 py-1 rounded-full bg-white border border-slate-200'>
            <strong>{key}:</strong> {result?.[key] ?? '-'}
          </span>
        ))}
      </div>

      {Array.isArray(result?.errorDetails) && result.errorDetails.length > 0 && (
        <div>
          <p className='text-xs font-semibold text-red-700 mb-1'>Errores</p>
          <ul className='text-xs text-slate-600 space-y-1'>
            {result.errorDetails.slice(0, 8).map((detail, index) => (
              <li key={`${detail?.row ?? 'row'}-${index}`} className='bg-white border border-red-100 rounded-lg p-2'>
                Fila {detail?.row ?? '-'}: {detail?.error ?? detail?.message ?? JSON.stringify(detail)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default UploadResult
